/**
 * Constants and Placeholders for My WSS Feature
 */

/**
 * Default cluster code placeholder
 */
export const CLUSTER_CODE_PLACEHOLDER = {
  SH3_Name__c: null,
  SH3_Code__c: null,
  Cluster_Description__c: "",
  CLUSTER_CODE__c: "",
};

/**
 * Default territory autocomplete placeholder
 */
export const TERRITORY_PLACEHOLDER = {
  attributes: null,
  Id: null,
  SH2_Name__c: null,
  SH2_Code__c: null,
  Name: null,
  SH3_Code__c: null,
};

/**
 * Default WSS placeholder
 */
export const WSS_PLACEHOLDER = {
  attributes: null,
  Id: null,
  CustomerName__c: null,
  DealerClass__c: null,
  DealerType1__c: null,
  WSS_latitude__c: null,
  WSS_longitude__c: null,
  Updated_WSS_latitude__c: null,
  Updated_WSS_longitude__c: null,
  PrimaryTSICode__c: null,
  Customer_Code__c: null,
  RecordTypeId: null,
};

/**
 * Default GPS coordinates (Pune, India)
 */
export const DEFAULT_COORDINATES = {
  latitude: 18.516726,
  longitude: 73.856255,
};

/**
 * Check-in distance threshold in meters
 */
export const CHECK_IN_DISTANCE_THRESHOLD = 100; // meters

/**
 * User types that require special cluster filtering
 */
export const SPECIAL_USER_TYPES = ["MH3", "RBDM Collaborator"];

/**
 * User types that can auto-populate from MTP
 */
export const MTP_ENABLED_USER_TYPES = ["SH6", "SH5", "MH3", "RBDM Collaborator"];

/**
 * User type that requires audit popup
 */
export const AUDIT_USER_TYPE = "HO Auditor";

/**
 * Loading states
 */
export const LOADING_STATES = {
  LOADING: "Loading",
  SUCCESS: "true",
  NO_DATA: "false",
};

/**
 * PowerBI sales group configurations
 */
export const POWERBI_SALES_GROUPS = {
  STANDARD_SPEEDOMETER: [105, 107, 111, 112, 401, 406, 901, 902],
  MNT_ASF_SPEEDOMETER: [201, 202, 301, 302, 303],
};

/**
 * PowerBI report configurations
 */
export const POWERBI_REPORTS = {
  MY_WSS: {
    id: "7d086498-f679-4a6b-b1bf-892ad94f12f7",
    pageName: {
      id: "13d818c72971a4547786",
      name: "My WSS",
    },
  },
  WSS_SPEEDOMETER: {
    id: "ef4cdf5f-c585-49b4-8970-b207058e8d01",
    pageName: {
      id: "97cae0c421b56c060431",
      name: "WSS Speedometer",
    },
  },
  WSS_SPEEDOMETER_MNT_ASF: {
    id: "f43a6603-fa38-4a2e-bdd0-2ed657c8158e",
    pageName: {
      id: "4d8aeed31c46261754ea",
      name: "WSS Speedometer- MNT & ASF",
    },
  },
};

/**
 * Error messages
 */
export const ERROR_MESSAGES = {
  LOCATION_DISABLED: "Please turn on your location",
  LOCATION_PERMISSION_DENIED:
    "Location access denied. Please update your browser settings to grant location permission.",
  REQUIRED_FIELDS: "Please select cluster, territory & WSS name!",
  ALREADY_CHECKED_IN: "You are already Checked-in for this WSS!",
  CHECK_IN_UNSUCCESSFUL: "Wss Check-in Unsuccessful",
  SELECT_WSS_FOR_DIARY: "Please select WSS to view and submit my diary",
  SELECT_WSS_FOR_SR: "Please select WSS to view and submit my SR",
  SELECT_WSS_FOR_OBSERVATIONS:
    "Please select WSS to view and submit previous observations",
};

/**
 * Success messages
 */
export const SUCCESS_MESSAGES = {
  CHECK_IN_SUCCESS: (wssName) =>
    `Successfully checked-in for ${wssName ? wssName : "this"} wss!`,
};

/**
 * Modal messages
 */
export const MODAL_MESSAGES = {
  RE_CAPTURE_LOCATION: "Do you want to Re-capture correct WSS location?",
  WSS_CHECK_IN_UNSUCCESSFUL: "WSS Check-In Unsuccessfull",
};

/**
 * Audit popup field options
 */
export const AUDIT_OPTIONS = {
  YES_NO: ["Yes", "No"],
};

/**
 * Record type name for WSS check-in
 */
export const RECORD_TYPE_NAME = "Visit Plan WSS";

/**
 * Division code for RBDM/STI users
 */
export const RBDM_STI_DIVISION = 70;
